<ion-header mode="md">
  <ion-toolbar color="primary">
    <ion-buttons slot="start">
      <ion-button>
        <ion-icon color="favorite" slot="icon-only" aria-hidden="true" name="call"></ion-icon>
      </ion-button>
    </ion-buttons>
    <ion-title color="favorite">Eingehender Anruf</ion-title>
    <ion-buttons slot="end">
      <ion-button (click)="dismiss()" aria-label="Close">
        <ion-icon slot="icon-only" name="close"></ion-icon>
      </ion-button>
    </ion-buttons>
  </ion-toolbar>
</ion-header>

<ion-content class="ion-padding">
  @if (call$ | async; as call) {
    <app-call-info [call]="call" (navigated)="dismiss()"></app-call-info>
  }
</ion-content>

<ion-footer>
  <ion-toolbar mode="md">
    <ion-button expand="block" (click)="dismiss()">Close</ion-button>
  </ion-toolbar>
</ion-footer>

